import { render, staticRenderFns } from "./loadingIcon.vue?vue&type=template&id=2a710374&"
import script from "./loadingIcon.vue?vue&type=script&lang=js&"
export * from "./loadingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports